import { FlexBox, Icon, Page } from '@dixa/lib-shared-habla';
import { useParams } from 'react-router-dom';
import { useMount } from 'react-use';

import { AppLink } from 'components/appLink';
import { withTeams, WithTeamsInjectedProps } from 'hocs';

import { TeamsAgents } from '../teamsAgents/teamsAgents';

export type TeamsDetailsPageProps = WithTeamsInjectedProps;

const TeamsDetailsPageImpl = ({
  teams,
}: TeamsDetailsPageProps): JSX.Element => {
  const { id } = useParams<'id'>();

  useMount(() => {
    if (id) {
      teams.getItem(id);
    }
  });

  const { item } = teams;

  return (
    <Page>
      <Page.Head
        title={
          <FlexBox gap="200" alignItems="center">
            <AppLink path="/settings/teams" style={{ color: 'inherit' }}>
              Teams
            </AppLink>

            <Icon name="angle-right" />

            {item?.name}
          </FlexBox>
        }
      />

      <Page.Body>{item && <TeamsAgents teamId={item.id} />}</Page.Body>
    </Page>
  );
};

export const TeamsDetailsPage = withTeams(TeamsDetailsPageImpl);
